import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import * as S from './GoldPriceChartStyle';
import Loading from '../Loading/Loader';
import axios from 'axios';

const GoldPriceChart = () => {
    const [series, setSeries] = useState([]);
    const [activeFilter, setActiveFilter] = useState('7D');
    const [isLoading, setIsLoading] = useState(true);

    const chartOptions = {
        chart: {
            type: 'area',
            height: 350,
            toolbar: { show: false },
            zoom: { enabled: false },
        },
        theme: {
            mode: 'dark',
        },
        dataLabels: { enabled: false },
        stroke: {
            curve: 'smooth',
            width: 3,
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.7,
                opacityTo: 0.2,
                stops: [0, 90, 100],
            },
        },
        colors: ['#ffb86c'],
        xaxis: {
            type: 'datetime',
            labels: {
                format: 'dd MMM yy',
                style: {
                    colors: '#bd93f9'
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            labels: {
                formatter: (value) => `R$ ${value ? value.toFixed(2) : '0.00'}`,
                style: {
                    colors: '#bd93f9'
                }
            },
        },
        tooltip: {
            x: {
                format: 'dd MMM yyyy',
            },
            y: {
                formatter: (value) => `R$ ${value.toFixed(2)}`,
            },
            theme: 'dark',
        },
        grid: {
            borderColor: '#44475a',
            strokeDashArray: 5,
        },
        markers: {
            size: 0,
            hover: {
                size: 5
            }
        }
    };

    useEffect(() => {
        const getDaysFromFilter = (filter) => {
            switch (filter) {
                case '7D': return 7;
                case '1M': return 30;
                case '6M': return 180;
                case '1A': return 365;
                case 'TUDO': return 1825; // 5 anos
                default: return 365;
            }
        };

        const fetchData = async () => {
            setIsLoading(true);
            try {
                const days = getDaysFromFilter(activeFilter);
                const url = `https://economia.awesomeapi.com.br/json/daily/XAU-BRL/${days}`;
                
                const response = await axios.get(url);

                if (!Array.isArray(response.data)) {
                    throw new Error("Resposta da API inválida");
                }
                
                const formattedData = response.data.map(item => {
                    const pricePerOunce = parseFloat(item.bid);
                    // 1 Onça Troy = 31.1035 gramas. Dividimos para ter o preço por grama.
                    const pricePerGram = pricePerOunce / 31.1035; // <-- AQUI ESTÁ A MÁGICA

                    return [
                        parseInt(item.timestamp) * 1000,
                        pricePerGram
                    ];
                }).reverse();

                setSeries([{ name: 'Preço da Grama do Ouro', data: formattedData }]);

            } catch (error) {
                console.error("Erro ao buscar dados da cotação do ouro:", error);
                setSeries([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [activeFilter]);

    const filters = ['7D', '1M'];

    return (
        <S.ChartContainer>
            <S.ChartHeader>
                <S.Title>Cotação do Ouro (g)</S.Title>
                <S.FilterGroup>
                    {filters.map(filter => (
                        <S.FilterButton
                            key={filter}
                            active={activeFilter === filter}
                            onClick={() => setActiveFilter(filter)}
                        >
                            {filter}
                        </S.FilterButton>
                    ))}
                </S.FilterGroup>
            </S.ChartHeader>
            <S.ChartWrapper>
                {isLoading && (
                    <S.LoaderWrapper>
                        <Loading />
                    </S.LoaderWrapper>
                )}
                <Chart
                    options={chartOptions}
                    series={series}
                    type="area"
                    height={350}
                />
            </S.ChartWrapper>
        </S.ChartContainer>
    );
};

export default GoldPriceChart;